import { useEffect } from "react";

export default function Home() {
  useEffect(() => {
    document.title = "Fast Passport Center — Expedited & Emergency Passport Services Nationwide";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/";

    setLink("canonical", pageUrl);
    setMeta(
      "description",
      "Fast Passport Center provides expedited passport services nationwide — as fast as 24 hours. A+ BBB rated, registered U.S. Department of State courier. Serving Orlando, Tampa, Boca Raton, Key West, Panama City, and all U.S. cities."
    );

    const graph = [
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Registered U.S. Department of State passport courier providing expedited and emergency passport services nationwide. A+ BBB rated, 20+ years of experience.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        email: "contactus@fastpassportcenter.com",
        address: {
          "@type": "PostalAddress",
          streetAddress: "1629 K Street, Suite 300",
          addressLocality: "Washington",
          addressRegion: "DC",
          postalCode: "20006",
          addressCountry: "US",
        },
        areaServed: {
          "@type": "Country",
          name: "United States",
        },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "4.9",
          reviewCount: "1200",
        },
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data";
    document.getElementById("structured-data")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById("structured-data");
      if (existing) existing.remove();
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) canonical.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#f8f9fa] flex items-center justify-center px-4">
      <div className="text-center max-w-lg">
        <h1 className="text-2xl font-bold text-[#1A365D] mb-3">
          Fast Passport Center — Home Page
        </h1>
        <p className="text-[#64748b] text-sm leading-relaxed mb-6">
          This is a placeholder home page. The actual site contains city-specific landing pages for passport services.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="/cities/orlando"
            className="inline-flex items-center gap-2 bg-[#22C55E] hover:bg-[#16A34A] text-white font-semibold text-sm px-5 py-2.5 rounded-md transition-colors whitespace-nowrap"
          >
            Orlando
          </a>
          <a
            href="/cities/tampa"
            className="inline-flex items-center gap-2 bg-[#22C55E] hover:bg-[#16A34A] text-white font-semibold text-sm px-5 py-2.5 rounded-md transition-colors whitespace-nowrap"
          >
            Tampa
          </a>
          <a
            href="/states/florida"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-5 py-2.5 rounded-md transition-colors whitespace-nowrap"
          >
            Florida
          </a>
        </div>
      </div>
    </div>
  );
}